"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParseXml = ParseXml;
exports.adaptSimpleAttributes = adaptSimpleAttributes;
exports.xmlBool = xmlBool;
exports.xmlNum = xmlNum;
exports.xmlInt = xmlInt;
const xml_js_1 = require("xml-js");
function ParseXml(input) {
    const tree = (0, xml_js_1.xml2js)(input, { compact: true });
    inlineAttributesInPlace(tree);
    return tree;
}
function inlineAttributesInPlace(input) {
    if (input === null || typeof input !== 'object') {
        return;
    }
    if (Array.isArray(input)) {
        for (const item of input) {
            inlineAttributesInPlace(item);
        }
        return;
    }
    const attrs = input._attributes;
    if (attrs && typeof attrs === 'object') {
        for (const key of Object.keys(attrs)) {
            input[`$${key}`] = attrs[key];
        }
    }
    for (const key of Object.keys(input)) {
        if (key.charCodeAt(0) === 36 || key === '_attributes') {
            continue;
        }
        const value = input[key];
        if (typeof value !== 'object') {
            throw new Error(`Unexpected value type ${typeof value} for key ${key}`);
        }
        inlineAttributesInPlace(value);
    }
}
function adaptSimpleAttributes(attrs, obj, typename, requireAllAttrs = false) {
    let foundAttrs = 0;
    const result = {};
    for (const key of Object.keys(obj)) {
        if (!key.startsWith('$')) {
            continue;
        }
        const attr = key.substring(1);
        if (!attrs.str[attr] && !attrs.num[attr] && !attrs.bool[attr]) {
            throw new Error(`Unexpected key ${key} in ${typename}`);
        }
        ++foundAttrs;
        result[attr] = obj[key];
    }
    if (requireAllAttrs && foundAttrs !== attrs.length) {
        throw new Error(`Missing keys in ${typename}`);
    }
    return result;
}
function xmlBool(value) {
    if (value === undefined) {
        return undefined;
    }
    if (typeof value === 'string') {
        return value === '1';
    }
    if (typeof value === 'number') {
        return value === 1;
    }
    if (typeof value === 'boolean') {
        return value;
    }
    throw new Error(`Unexpected value for boolean type ${typeof value}`);
}
function xmlNum(value) {
    if (typeof value === 'string') {
        value = value.trim();
        if (!/^(\+|-)?\d*(\.\d*)?$/.test(value)) {
            throw new Error(`Expected number value, got ${value}`);
        }
        return parseFloat(value);
    }
    if (typeof value === 'number') {
        return value;
    }
    throw new Error(`Unexpected value for number type ${typeof value}`);
}
function xmlInt(value) {
    if (typeof value === 'string') {
        value = value.trim();
        if (!/^(\+|-)?\d+$/.test(value)) {
            throw new Error(`Expected integer value, got ${value}`);
        }
        return parseInt(value);
    }
    if (typeof value === 'number') {
        return value;
    }
    throw new Error(`Unexpected value for number type ${typeof value}`);
}
//# sourceMappingURL=xmlutil.js.map